import { codeSchemaFields } from "../utils/code";
export const authRequestApiTemplate = {
  name: 'auth',
  desc: '第三方鉴权接口',
  dbMethod: '',
  required: false,
  methods: [{
    value: 'post'
  }],
  request: {
    body: {
      type: 'object',
      title: 'post参数',
      fields: [{
        id: 'rtx',
        type: 'string',
        required: true,
        title: '用户名'
      }, {
        id: 'projectId',
        type: 'string',
        required: true,
        title: '项目 ID'
      }, {
        id: 'envId',
        type: 'string',
        required: true,
        title: '环境 ID'
      }, {
        id: 'type',
        // path/api/permission
        type: 'string',
        required: true,
        title: '鉴权类型'
      }, {
        id: 'permission',
        type: 'string',
        required: false,
        title: '权限项'
      }, {
        id: 'path',
        type: 'string',
        required: false,
        title: '页面路由'
      }, {
        id: 'bizId',
        type: 'string',
        required: false,
        title: '业务隔离 ID'
      }, {
        id: 'api',
        type: 'string',
        required: false,
        title: '请求接口'
      }, {
        id: 'method',
        type: 'string',
        required: true,
        title: 'HTTP 方法'
      }]
    }
  },
  response: {
    body: {
      title: '响应body',
      type: 'object',
      fields: [{
        id: 'data',
        type: 'boolean',
        title: '是否有权限',
        required: true
      }, ...codeSchemaFields]
    }
  }
};
//# sourceMappingURL=auth.js.map
